import { render, staticRenderFns } from "./PersonalInfoTab.vue?vue&type=template&id=39a67f88&scoped=true&"
import script from "./PersonalInfoTab.vue?vue&type=script&lang=js&"
export * from "./PersonalInfoTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a67f88",
  null
  
)

export default component.exports